import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faStar, faHeart } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { current } from "@reduxjs/toolkit";

const Topbar = () => {
  const { currentUser, avatar } = useSelector((state) => state.user);
  console.log(currentUser, "scsadcsdc");

  return (
    <div className=" bg-[#f5f5f5] z-20 ">
      <div className="max-w-[1480px]  mx-auto flex justify-between items-center py-2 px-4 md:px-12 z-20">
        <p className="text-[#6b7280] text-[14px]">English(US)</p>
        <div className="flex justify-center items-center gap-4  text-[#1f2937] text-[14px]  ">
          <Link to="/favourites">
            <p className="hidden md:block cursor-pointer ">
              {" "}
              <FontAwesomeIcon
                icon={faHeart}
                size="sm"
                style={{ color: "#1f2937" }}
                className="px-1 text-[12px]"
              />
              Favourite Properties
            </p>
          </Link>

          {/* <p className="hidden md:block cursor-pointer">
            <FontAwesomeIcon
              icon={faStar}
              size="sm"
              style={{ color: "#1f2937" }}
              className="px-1"
            />
            Saved Searches
          </p> */}

          <div className=" cursor-pointer flex gap-[6px] justify-center items-center">
            {currentUser ? (
              <Link
                to="/profile"
                className=" cursor-pointer flex gap-[6px] justify-center items-center"
              >
                <img src={avatar} alt="" className="w-[20px] rounded-full" />
                <p className="">{currentUser?.name}</p>
              </Link>
            ) : (
              <Link
                to="/signin"
                className=" cursor-pointer flex gap-[6px] justify-center items-center"
              >
                <FontAwesomeIcon
                  icon={faUser}
                  size="sm"
                  style={{ color: "#1f2937" }}
                  className="px-1"
                />
                <p>Sign In</p>
              </Link>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Topbar;
